import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Dm from '../views/Dm.vue'
import More from '../views/More.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/dm',
    name: 'Dm',
    component: Dm
  },
  {
    path: '/more',
    name: 'More',
    component: More
  }
]

const router = new VueRouter({
  routes
})

export default router
